"use client";

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CaretUpDown as CaretUpDownIcon } from "@phosphor-icons/react/dist/ssr/CaretUpDown";

import { usePopover } from "@/hooks/use-popover";

import { workspaces, WorkspacesPopover } from "./workspaces-popover";
import { useWorkspace } from "./vertical/workspace-context";
import { useNavigate } from "react-router-dom";

import { hasFeature } from "../../feature/hasFeature";
import { useUser } from "../../../api/hooks";

export function WorkspacesSwitch(): React.JSX.Element {
	const popover = usePopover<HTMLDivElement>();
    const { workspace } = useWorkspace();
    const navigate = useNavigate();

    const { data: user, isLoading } = useUser();

    if (isLoading) {
        return null;
    }
    const canShowWorkspace = hasFeature(user, "workspace:show");

    if (!canShowWorkspace) {
        return null;
    }

    const currentWorkspace =
        workspaces.find((w) => w.id === workspace) ?? workspaces[0];
  
	return (
		<React.Fragment>
			<Stack
				direction="row"
				onClick={popover.handleOpen}
				ref={popover.anchorRef}
				spacing={2}
				sx={{
					alignItems: "center",
					border: "1px solid var(--Workspaces-border-color)",
					borderRadius: "12px",
					cursor: "pointer",
					p: "4px 8px",
				}}
            >
                <Avatar src={currentWorkspace.avatar} variant="rounded" />
				<Box sx={{ flex: "1 1 auto" }}>
				
					<Typography color="var(--Workspaces-name-color)" variant="subtitle2">
                        {currentWorkspace.name}
					</Typography>
				</Box>
				<CaretUpDownIcon color="var(--Workspaces-expand-color)" fontSize="var(--icon-fontSize-sm)" />
			</Stack>
            <WorkspacesPopover
                anchorEl={popover.anchorRef.current}
                open={popover.open}
                onClose={popover.handleClose}
                onChange={(workspaceId) => {

                    if (workspaceId === "default") {
                        navigate("/dashboard");
                    }

                    if (workspaceId === "workspaceB") {
                        navigate("/dashboard/workspace/usermanagement");
                    }

                    popover.handleClose();
                }}
            />
		</React.Fragment>
	);
}
